var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.843 3.45494C20.5375 2.14899 18.7666 1.41528 16.92 1.41528C15.0734 1.41528 13.3025 2.14899 11.997 3.45494L1.619 13.8319C-0.366862 15.8374 -0.358936 19.0705 1.63673 21.0662C3.6324 23.0619 6.86557 23.0698 8.871 21.0839L17.3 12.6529C18.1858 11.8331 18.5522 10.5944 18.2548 9.42468C17.9574 8.25494 17.0439 7.34162 15.8741 7.04447C14.7042 6.74731 13.4656 7.11394 12.646 7.99994L7.457 13.1839C7.20406 13.4365 7.10508 13.8049 7.19735 14.1502C7.28963 14.4956 7.55914 14.7655 7.90435 14.8582C8.24957 14.951 8.61806 14.8525 8.871 14.5999L14.06 9.40894C14.5686 8.92367 15.3716 8.93321 15.8685 9.43041C16.3655 9.92762 16.3745 10.7306 15.889 11.2389L7.457 19.6699C6.23535 20.8916 4.25465 20.8916 3.033 19.6699C1.81135 18.4483 1.81135 16.4676 3.033 15.2459L13.411 4.86894C15.349 2.93098 18.491 2.93098 20.429 4.86894C22.367 6.80691 22.367 9.94898 20.429 11.8869L12.646 19.6699C12.386 19.921 12.2818 20.2928 12.3733 20.6425C12.4648 20.9921 12.7379 21.2651 13.0875 21.3566C13.4371 21.4482 13.8089 21.3439 14.06 21.0839L21.843 13.2999C23.1492 11.9946 23.8831 10.2236 23.8831 8.37694C23.8831 6.53028 23.1492 4.75932 21.843 3.45394V3.45494Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.66dab5ac.svg";
export { ForwardRef as ReactComponent };